export interface GetAllChutesHttpResponse {
  items: ChuteDto[];
}

export interface ChuteDto {
  id: number;
  number: number;
  status: ChuteStatus;
  sortingDirectories: SortingDirectoryDto[];
}

export enum ChuteStatus {
  Normal,
  Locked,
  Disabled,
}

export interface SortingDirectoryDto {
  id: number;
  bagCode: string;
}

export interface GetAllBagCodesHttpResponse {
  items: BagCodeDto[];
}

export interface BagCodeDto {
  sortingDirectoryId: number;
  bagCode: string;
}

export type ActionBagCodesRequest = {
  chuteId: number;
  sortingDirectoryId: number;
};
